<template>
  <div id="app" class="wrap">
    <Header />
    <Navi />
    <Search />
    <Sidemenu />
    <Cart />
    <router-view />
    <Footer />
    <Login />
    <NewsletterForm />
    <Cookies
      v-if="show_cookies && $store.state.cookies"
      @close="show_cookies = false"
    />
    <Notification
      v-if="$store.state.notification && $store.state.notification.is_show"
      :is_show_cookies="show_cookies"
    />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navi from "@/components/Navi.vue";
import Sidemenu from "@/components/SideMenu.vue";
import Cart from "@/components/Cart.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
import NewsletterForm from "@/components/NewsletterForm.vue";
import Search from "@/components/Search.vue";
import Cookies from "@/components/Cookies.vue";
import Form from "@/utils/ContactForm";
import Notification from "@/components/Notification.vue";

export default {
  name: "app",

  components: {
    Header,
    Navi,
    Footer,
    Login,
    Sidemenu,
    Cart,
    NewsletterForm,
    Search,
    Cookies,
    Notification
  },

  data() {
    return {
      current_scroll_position: 0,
      offset: 1,
      show_cookies: false,
      is_init: false
    };
  },

  watch: {
    $route(newRoute, oldRoute) {
      if (this.is_init && typeof window.ga === "function") {
        setTimeout(() => {
          gtag("event", "page_view", {
            page_path: location.pathname
          });
        }, 1000);
      } else {
        this.is_init = true;
      }
    },
    "$route.params": {
      handler(params) {
        this.updateClass(params);
      },

      immediate: true
    }
  },

  methods: {
    updateClass(params) {
      // this.$store.state.show_navi = false;
      let body_class = "";
      if (this.$route.name !== "home") body_class = "not-home ";
      if (typeof this.$route.name === "string")
        body_class = body_class + "page-" + this.$route.name;
      if (params.slug) body_class = body_class + " slug-" + params.slug;
      if (params.category)
        body_class = body_class + " category-" + params.category;

      document.body.className = body_class;
      this.$store.state.show_menus = false;

      // if (JSON.stringify(this.$route.query) === '{}')  window.scrollTo(0, 0);
      // console.log(this.$store.state.disabled_scroll)

      if (this.$store.state.disabled_scroll) {
        this.$store.state.disabled_scroll = false;
      } else {
        window.scrollTo(0, 0);
      }

      setTimeout(() => {
        let forms = document.querySelectorAll(".wpcf7");
        forms.forEach(e => {
          if (!e.classList.contains("inited")) {
            console.log(e);
            let wpcf = new Form(e, window.globals.home_url);
            wpcf.init();
          }
        });
      }, 1000);
    },

    onScroll() {
      const current_scroll_position =
        window.pageYOffset || document.documentElement.scrollTop;

      if (current_scroll_position > this.offset) {
        document.body.classList.add("is-sticky");
      } else {
        document.body.classList.remove("is-sticky");
      }

      // if (current_scroll_position < this.offset) {
      //     this.show_header = false;
      //     return;
      // }

      // this.show_header = current_scroll_position < this.last_scroll_position;
      if (current_scroll_position < this.last_scroll_position) {
        document.body.classList.add("show-header");
      } else {
        document.body.classList.remove("show-header");
      }

      this.last_scroll_position = current_scroll_position;
    }
  },

  mounted() {
    if (window.localStorage.getItem("hide_cookies") === null)
      this.show_cookies = true;

    if (window.globals.is_logged && window.globals.user) {
      this.$store.state.is_logged = true;
      this.$store.state.user = window.globals.user;
    }

    window.addEventListener("scroll", this.onScroll);
  }
};
</script>
<style lang="scss">
@import "@/assets/sass/variable";
@import "@/assets/sass/fonts";
@import "@/assets/sass/reset";

/********* Base */
$padding: 2.2rem;

:root {
  --outer-size: 108rem;
  --inner-size: 81rem;
  --base-size: 1.6rem;
  --medium-size: 3.25rem;
  --small-size: 1.25rem;
  --title-size: 6.25rem;
  --letter-spacing: 0rem;

  --padding-25: calc(#{$padding}/ 4);
  --padding-50: calc(#{$padding} / 2);
  --padding: #{$padding};
  --padding-x2: #{$padding * 2};
  --padding-x3: #{$padding * 3};
  --padding-x4: #{$padding * 4};
  --padding-x5: #{$padding * 5};

  --font-color: #{$font_color};
  --bg-color: #fff;
  --light-gray: #{$light_gray};
  --dark-gray: #{$dark_gray};
  --gray: #b4b9ba;
  --green: rgb(55, 61, 0);
  --green-2: rgb(101, 199, 94);
  --yellow: #{$yellow};
  --orange: #{$orange};
  --footer-1: #7a8700;
  --footer-2: #ffc700;
  --footer-3: #e1ff60;

  --theme-1-color-1: #e1f500; /* yellow, home page, footer */
  --theme-1-color-2: #787800; /* olive, stay in touch */
  --theme-1-color-3: #ff96dc; /* pink, footer links */
  --theme-1-color-4: #5ac86e; /* green, whatson */
  --theme-1-color-5: #144641; /* petrol, newsletter, workshop events*/
  --theme-1-color-6: #ff5465; /* family events */

  --theme-2-color-1: #ffaf00; /* orange, home page, footer */
  --theme-2-color-2: #787800; /* olive, stay in touch */
  --theme-2-color-3: #ff00dc; /* magenta, footer links */
  --theme-2-color-4: #5ac86e; /* green, whatson */
  --theme-2-color-5: #870087; /* petrol, newsletter*/

}

html, body {
  scroll-behavior: smooth;
}

html.theme-color-1 {
  body.page-home .logo .bottom {
    fill: var(--theme-1-color-1) !important;
  }
  .home-related,
  .grey-content .bg-content-block.color-green,
  .details-content .bg-content-block.color-green,
  .bg-content-block.color-green .ui-enter {
    background: var(--theme-1-color-1) !important;
  }
  body.page-peoples a:hover {
    color: var(--theme-1-color-1) !important;
  }
  .newsletter .col {
    background: var(--theme-1-color-2) !important;
  }
  .footer {
    background: var(--theme-1-color-1) !important;
    color: black !important;
    a,
    a:active,
    a:hover,
    a:visited {
      color: black !important;
    }
    .links li {
      color: black !important;
      a {
        fill: black !important;
      }
    }
    .ui-button.color-white {
      color: black !important;
      border-color: black !important;
      &:hover {
        background: black !important;
        color: white !important;
      }
    }
  }
  body.page-home .footer {
    background: black !important;
    color: white !important;
    a,
    a:active,
    a:hover,
    a:visited {
      color: white !important;
    }
    .links li {
      color: var(--theme-1-color-3) !important;
      a {
        color: var(--theme-1-color-3) !important;
      }
    }
    .ui-button.color-white {
      color: white !important;
      border-color: white !important;
      &:hover {
        background: white !important;
        color: black !important;
      }
    }
  }

  body.page-whats-on,
  body.page-whats-on .navi {
    background: var(--theme-1-color-4) !important;
  }

  &.newsletter-form-html,
  .newsletter-form {
    background: var(--theme-1-color-5) !important;
  }
}

html.theme-color-2 {
  body.page-home .logo .bottom {
    fill: var(--theme-2-color-1) !important;
  }
  .home-related,
  .grey-content .bg-content-block.color-green,
  .details-content .bg-content-block.color-green,
  .bg-content-block.color-green .ui-enter {
    background: var(--theme-2-color-1) !important;
  }
  body.page-peoples a:hover {
    color: var(--theme-2-color-1) !important;
  }
  .newsletter .col {
    background: var(--theme-2-color-2) !important;
  }
  .footer {
    background: var(--theme-2-color-1) !important;
    color: black !important;
    a,
    a:active,
    a:hover,
    a:visited {
      color: black !important;
    }
    .links li {
      color: black !important;
      a {
        color: black !important;
      }
    }
    .ui-button.color-white {
      color: black !important;
      border-color: black !important;
      &:hover {
        background: black !important;
        color: white !important;
      }
    }
  }
  body.page-home .footer {
    background: black !important;
    color: white !important;
    a,
    a:active,
    a:hover,
    a:visited {
      color: white !important;
    }
    .links li {
      color: var(--theme-2-color-3) !important;
      a {
        color: var(--theme-2-color-3) !important;
      }
    }
    .ui-button.color-white {
      color: white !important;
      border-color: white !important;
      &:hover {
        background: white !important;
        color: black !important;
      }
    }
  }
  body.page-whats-on,
  body.page-whats-on .navi {
    background: var(--theme-2-color-4) !important;
  }

  &.newsletter-form-html,
  .newsletter-form {
    background: var(--theme-2-color-5) !important;
  }
}

html.large-size {
  --base-size: 1.92rem; /* 1.6 x 1.2 */
  --medium-size: 3.9rem; /* 3.25 x 1.2 */
  --small-size: 1.5rem; /*1.25 x 1.2 */
  --title-size: 7.5rem; /* 6.25 x 1.2 */
}

html.high-contrast {
  body.page-home .logo .bottom {
    fill: var(--theme-2-color-1) !important;
  }
  .home-related,
  .home-menus ul li a {
    background: white !important;
  }
  .newsletter .col,
  .bg-content-block.color-green .ui-enter,
  body.page-whats-on,
  body.page-whats-on .navi {
    background: var(--theme-2-color-1) !important;
  }
  .footer {
    background: black !important;
    color: white !important;
    a,
    a:active,
    a:hover,
    a:visited {
      color: white !important;
    }
    .links li {
      color: var(--theme-2-color-1) !important;
      a {
        color: var(--theme-2-color-1) !important;
      }
    }
    .ui-button.color-white {
      color: white !important;
      border-color: white !important;
      &:hover {
        background: white !important;
        color: black !important;
      }
    }
  }
  .post-wrap .related-items {
    background: var(--dark-gray) !important;
  }
}

input,
text,
keygen,
select,
button,
meter,
progress {
  font-family: $font;
}

/********* Links */
a,
a:visited,
a:active {
  color: $font_color;
  outline: none;
  text-decoration: none;
  // transition: color .2s;
}

a:hover {
  text-decoration: none;
  color: $font_color;
  opacity: 0.5;
  // color: $red;
}

input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}

strong,
b {
  font-weight: 400;
}

i,
em {
  font-style: italic;
}

.mobile-item {
  display: none;
}

.desktop-item {
  display: block;
}

html {
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-size: 1vw; // this value is currently in use
  background-color: #fff;
}



html body {
  font-family: $font;
  color: var(--font-color);

  /* Font smoothing */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--base-size);
  min-height: 100vh;
  line-height: 1.4;
  background-color: var(--theme-color-bg);

  // &.loading,
  // &.loading * {
  //     cursor: wait;
  // }
}

i,
em {
  font-style: normal;
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// .wrap {
//     overflow: hidden;
// }

// .wrap {
//     min-height: 100vh;
//     display: grid;
//     grid-template-rows: 1fr auto;
//     grid-template-columns: 100%;
// }

.inner {
  width: var(--inner-size);
  margin-left: auto;
  margin-right: auto;
}

.page-wrap {
  width: var(--inner-size);
  margin-left: auto;
  margin-right: auto;
  padding-bottom: var(--padding-x2);

  .page-title {
    margin: var(--padding) 0;
    font-size: var(--medium-size);
    line-height: 1.2;
  }
}

.load-more {
  text-align: center;
  padding: var(--padding) 0 var(--padding-x2);

  .ui-button {
    cursor: pointer;
  }
}

.woocommerce * {
  font-weight: normal !important;
  font-weight: unset !important;
  p a {
    border-bottom: 1px solid;
  }
}

.woocommerce form .form-row input.input-text,
.woocommerce form .form-row textarea {
  padding: var(--padding);
  border: 1px solid var(--gray);

  &:focus {
    border-color: black;
  }
}

.woocommerce-account .woocommerce-MyAccount-navigation {
  float: none;
  width: auto;

  ul {
    display: flex;

    a {
      display: block;
      height: 4.2rem;
      line-height: 4.26rem;
      padding: 0 2rem;
    }

    .is-active a {
      background: var(--gray);
    }

    .woocommerce-MyAccount-navigation-link--customer-logout {
      flex: 1;
      text-align: right;

      a {
        display: inline-block;
      }
    }
  }
}

.woocommerce-account .woocommerce-MyAccount-content {
  padding: var(--padding) 0;
  float: none;
  width: auto;
}

.woocommerce .col2-set,
.woocommerce-page .col2-set {
  margin: var(--padding-x2) 0;
}

.woocommerce form .show-password-input,
.woocommerce-page form .show-password-input {
  top: auto;
}

.woocommerce-info {
  border-top: black;
  &::before {
    color: black;
  }
}

.woocommerce #respond input#submit.alt,
.woocommerce a.button.alt,
.woocommerce button.button.alt,
.woocommerce input.button.alt {
  background-color: black;
}

.woocommerce #respond input#submit.alt:hover,
.woocommerce a.button.alt:hover,
.woocommerce button.button.alt:hover,
.woocommerce input.button.alt:hover {
  background-color: var(--dark-gray);
}

.woocommerce form .form-row .select2-container {
  line-height: 5rem;
}

.select2-container .select2-selection--single {
  height: 5rem;
}

.select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  line-height: 5rem;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  width: 5rem;
  height: 5rem;
}

.select2-container--default
  .select2-results__option--highlighted[aria-selected],
.select2-container--default
  .select2-results__option--highlighted[data-selected] {
  background-color: black;
}

.woocommerce form .form-row textarea {
  height: 10em;
}

#app .wpcf7 {
  margin: var(--padding) 0;
  position: relative;

  &.is-loading {
    opacity: 0.5;

    &::before {
      position: absolute;
      z-index: 9;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      content: "";
      cursor: wait;
    }
  }

  p {
    margin: 0 0 var(--padding-50) 0;
  }

  select,
  textarea,
  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="password"] {
    padding: var(--padding-25);
    border: 1px solid var(--gray);
    margin: var(--padding-25) 0;
    display: block;
  }

  span.error {
    select,
    textarea,
    input[type="text"],
    input[type="email"],
    input[type="tel"],
    input[type="password"] {
      border-color: red;
    }
  }

  .wpcf7-response-output {
    font-size: var(--small-size);
    padding: 0;
    margin: 0;
    border: none;

    &.error {
      color: red;
    }

    &.success {
      color: var(--green-2);
    }
  }
}

@media only screen and (min-width: 1270px) {
  html {
    font-size: 13px !important;
  }
}

@media only screen and (orientation: portrait) and (min-width: 768px) {
  .featured-items {
    .item a img {
      max-width: calc(100vh - 55rem) !important;
      max-height: calc(100vh - 55rem) !important;
    }
  }
}

@media only screen and (max-width: 767px) {
  $padding: 5rem;

  :root {
    --inner-size: 90rem;
    --base-size: 5rem;
    --medium-size: 7rem;
    --tiny-size: 3rem;
    --small-size: 4rem;
    --title-size: 10rem;
    --letter-spacing: 0rem;

    --padding-25: calc(#{$padding} / 4);
    --padding-50: calc(#{$padding} / 2);
    --padding: #{$padding};
    --padding-x2: #{$padding * 2};
    --padding-x3: #{$padding * 3};
    --padding-x4: #{$padding * 4};
  }

  html.large-size {
    --base-size: 6rem; /* 5 x 1.2 */
    --medium-size: 8.4rem; /* 7 x 1.2 */
    --small-size: 4.8rem; /*4 x 1.2 */
    --title-size: 12rem; /* 10 x 1.2 */
  }
  .woocommerce-account {
    .woocommerce-MyAccount-navigation {
      ul {
        display: block;
        a {
          padding: 0;
          height: var(--padding);
          line-height: 1.2;
        }

        .is-active a {
          background: 0;
          color: var(--gray);
        }
      }
    }
  }

  .woocommerce form .form-row input.input-text,
  .woocommerce form .form-row textarea {
    font-size: var(--small-size);
  }

  .select2-container .select2-selection--single {
    height: var(--padding-x3);
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__rendered {
    line-height: var(--padding-x3);
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    width: var(--padding-x3);
    height: var(--padding-x3);
  }

  .woocommerce #payment #place_order,
  .woocommerce-page #payment #place_order {
    margin-top: 1em;
  }

  #app .coupon .input-text {
    float: none;
    width: 100%;
    padding: 3rem;
    margin: 0 0 2rem;
  }

  #app .coupon .button {
    float: none;
    width: 100%;
  }
}

.newsletter-form-html {
  background: var(--green);
}

.newsletter-form-box {
  color: white;
  max-width: 59rem;
  padding: var(--padding);
  margin: 0 auto;

  h3 {
    font-size: var(--title-size);
    text-align: center;
    line-height: 1.05;
    padding: var(--padding) 0;
  }

  .pb-hide-if-postcode-suggesting {
    display: none;
  }

  form {
    .error {
      display: block;
    }

    & > p {
      font-size: var(--base-size);
      line-height: 1.2;
      margin: var(--padding) 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      & > label {
        font-size: var(--base-size);
        width: 10rem;
      }

      @media only screen and (max-width: 767px) {
        & > label {
          flex: 1;
        }
      }

      .compulsory {
        padding-left: 0.25rem;
        color: var(--wc-red);
      }

      & > select,
      & > input {
        border: none;
        flex: 1;
        padding: var(--padding-25) var(--padding-50);
        box-sizing: border-box;
        border-radius: 0px;
        height: auto;
        font-size: var(--base-size);
      }
    }
  }

  .submit {
    margin: var(--padding-50) 0;

    display: block;
    line-height: 1;
    border: 2px solid;
    text-align: center;
    cursor: pointer;
    padding: 1rem 3rem;
    font-size: var(--medium-size);
    line-height: 1.2;
    color: white;
    background: transparent;
    margin: 0 auto;

    &:hover {
      color: white;
      background-color: black;
    }
  }

  .newsletter-form-box {
    max-width: 100rem;
  }
}
</style>
